import { Base, Component, Prop, Provide } from '@/vue-property-decorator'
import { GameCardCommonProps, GameCardShape } from '../../../common.type'
import { GameCategoryIds } from '@/views/game/consts/categorys'
import { getProps } from './getProps'

/** 横向游戏卡片-标准版*/
export interface LandscapeProps extends GameCardCommonProps {
  /** 是否显示彩金池 */
  isJackpot?: boolean
  /** 平台宣传语 */
  description?: string
  /** 当前卡片类型id */
  categoryId?: GameCategoryIds
}

/** 横向游戏卡片 */
@Component<BasePropsConfig>({
  name: 'BasePropsConfig'
})
export default class BasePropsConfig extends Base<
  unknown,
  LandscapeProps,
  unknown
> {
  /** 通过传入原始数据,获取props */
  public static getProps = getProps

  @Prop({ default: GameCardShape.Landscape })
  protected inCardShape!: LandscapeProps['inCardShape']
  @Prop()
  protected inCardRenderCategory!: LandscapeProps['inCardRenderCategory']
  @Prop()
  protected status!: LandscapeProps['status']
  @Prop()
  protected isFavorited!: LandscapeProps['isFavorited']
  @Prop()
  protected gameName!: LandscapeProps['gameName']
  @Prop()
  protected description!: LandscapeProps['description']
  @Prop()
  protected imgUrl!: LandscapeProps['imgUrl']
  @Prop()
  protected logoUrl!: LandscapeProps['logoUrl']
  @Prop()
  protected isJackpot!: LandscapeProps['isJackpot']
  @Prop()
  protected bgImg!: LandscapeProps['bgImg']
  @Prop({ default: false })
  protected isMaintain!: LandscapeProps['isMaintain']
  @Prop({ default: false })
  protected isCompleteImage!: LandscapeProps['isCompleteImage']
  @Prop({ default: false })
  protected isCustomIcon!: LandscapeProps['isCustomIcon']
  @Prop({ default: true })
  protected isShowFavorited!: LandscapeProps['isShowFavorited']
  @Prop()
  protected categoryId!: LandscapeProps['categoryId']
  @Prop({ default: false })
  protected isAtSwiper!: LandscapeProps['isAtSwiper']
  @Prop()
  protected atSwiperDomId!: LandscapeProps['atSwiperDomId']
  @Prop()
  protected handleClickCard!: LandscapeProps['handleClickCard']
  @Prop()
  protected handleClickFavorIcon!: LandscapeProps['handleClickFavorIcon']

  // 将接收到的props依赖注入给子集
  @Provide('cardProps')
  protected get cardProps() {
    return this.$props as Required<LandscapeProps>
  }

  // 渲染入口.
  render() {
    return this.$slots.default as unknown as VueTsxSupport.JSX.Element
  }
}
